module.exports = __webpack_public_path__ + "static/img/main-banner1.3a463a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main-banner1.jpg
// module id = Nyr1
// module chunks = 2